require('./contractEasyLoanTypeCStep3.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @components
const { formatText, FormattedText } = require('core/i18n').i18n;
const EasyLoanRequestUpload = require('../easyLoanRequestUpload/easyLoanRequestUpload');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

const WebappRender = require('components/conditionalRender/webappRender');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const {
    easyLoanTypeUpload: {
        EASY_LOAN_CERTIFICATE,
    },
    EMPLOYER_WITH_SALARIES,
    EMPLOYER_WITHOUT_SALARIES,
    LIBERAL_PROFESSIONALS,
    FARMERS_AND_LIVESTOCK_BREEDERS
} = require('../../../../loansConstants/index');
class ContractEasyLoanTypeCStep3 extends React.Component {
    componentDidMount() {
        const { checkStepThree } = this.props;
        this.props.resetUploadConfig();
        this.props.loadFilesEasyLoan();
        __CONTACT_CENTER__ && checkStepThree()
    }

    buildTitle() {

        let finalText = formatText('easyLoanTypeCRequestStepThree-genericRequestMessageTitle');

        return (
            <div className="easy-loan-request-step-three__title">
                {finalText}
            </div>
        );
    }

    buildUploadMaxSizeText() {
        return (
            <div>
                <WebappRender>
                    <FormattedText
                        value="easyLoanTypeCRequestStepThree-uploadMaxSizeParagraph1"
                        className="easy-loan-request-step-three__caveat-text"
                    />
                </WebappRender>
                <div>
                    <ul>
                        <li>
                            <FormattedText
                                value="easyLoanTypeCRequestStepThree-uploadMaxSizeParagraph2"
                                className="easy-loan-request-step-three__caveat-text"
                            />
                            <FormattedText
                                value="easyLoanTypeCRequestStepThree-uploadSizeText"
                                className="easy-loan-request-step-three__bold"
                            />
                        </li>
                        <li>
                            <FormattedText
                                value="easyLoanTypeCRequestStepThree-uploadMaxSizeParagraph3"
                                className="easy-loan-request-step-three__caveat-text"
                            />
                            <FormattedText
                                value="easyLoanTypeCRequestStepThree-uploadMaxSizeExtensionsText"
                                className="easy-loan-request-step-three__bold"
                            />
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
    buildUploadMaxSizeTextCC() {
        const lists = [
            {
                title: "easyLoanTypeCRequestStepThree-trimestralModelList",
                valueListMXP2: "easyLoanTypeCRequestStepThree-uploadMaxSizeParagraph2",
                valueListUST: "easyLoanTypeCRequestStepThree-uploadSizeText",
                valueListMSP3: "easyLoanTypeCRequestStepThree-uploadMaxSizeParagraph3",
                valueListUMXET: "easyLoanTypeCRequestStepThree-uploadMaxSizeExtensionsText",
            },
            {
                title: "easyLoanTypeCRequestStepThree-irpfList",
                valueListMXP2: "easyLoanTypeCRequestStepThree-uploadMaxSizeParagraph2",
                valueListUST: "easyLoanTypeCRequestStepThree-uploadSizeText",
                valueListMSP3: "easyLoanTypeCRequestStepThree-uploadMaxSizeParagraph3",
                valueListUMXET: "easyLoanTypeCRequestStepThree-uploadMaxSizeExtensionsText",
            },
        ];


        return (
            <div>
                <WebappRender>
                    <FormattedText
                        value="easyLoanTypeCRequestStepThree-uploadMaxSizeParagraph1"
                        className="easy-loan-request-step-three__caveat-text"
                    />
                </WebappRender>
                <div className="easy-loan-request-step-three-list"  >
                    {lists.map((list, index) => (
                        <div className="easy-loan-request-step-three-container-list" key={index}>
                            <h4>{list.title}</h4>
                            <ul>
                                <li>
                                    <FormattedText
                                        value={list.valueListMXP2}
                                        className="easy-loan-request-step-three__caveat-text"
                                    />
                                    <FormattedText
                                        value={list.valueListUST}
                                        className="easy-loan-request-step-three__bold"
                                    />
                                </li>
                                <li>
                                    <FormattedText
                                        value={list.valueListMSP3}
                                        className="easy-loan-request-step-three__caveat-text"
                                    />
                                    <FormattedText
                                        value={list.valueListUMXET}
                                        className="easy-loan-request-step-three__bold"
                                    />
                                </li>
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
    render() {
        const title = this.buildTitle();
        const {
            immContractEasyLoan,
            loadFileInUpload,
            clearErrorsFile,
            removeUploadedFile,
            recordStatus,
            handlerEditFileName
        } = this.props;
        const requiredDocs = immContractEasyLoan.getIn(["upload", "requiredDocs"]);
        const employmentLevel = immContractEasyLoan.get("employmentLevel");
        const employmentLevelsToShow = [
            EMPLOYER_WITH_SALARIES,
            EMPLOYER_WITHOUT_SALARIES,
            LIBERAL_PROFESSIONALS,
            FARMERS_AND_LIVESTOCK_BREEDERS
        ];
        const nomVLRequired2 = typeof (requiredDocs.get(EASY_LOAN_CERTIFICATE)) === 'object'
        const ccInfo = (
            <BlockInfo>
                <FormattedText
                    value="easyLoanTypeCRequestStepThree-easyLoanRequestMessageForCC"
                    className="easy-loan-request-step-three__message"
                />
            </BlockInfo>
        );

        const officeText = (
            <div className="contract-easy-loan-step-three__officetext">
                <i className="icon-informacion"></i>
                <FormattedText value="easyLoanTypeCRequestStepThree-officeText" ></FormattedText>
            </div>
        )
        const isCCEnv = __CONTACT_CENTER__ && !isPrintOfficeMode()
        const maxSizeTextAllowedText = isCCEnv && !nomVLRequired2 ? this.buildUploadMaxSizeTextCC() : this.buildUploadMaxSizeText();
        return (
            <div className="easy-loan-request-step-three">
                {title}
                {isCCEnv ? ccInfo : <FormattedText
                    value="easyLoanTypeCRequestStepThree-almostDone"
                    className="easy-loan-request-step-three__message"
                />}
               {employmentLevelsToShow.includes(employmentLevel) && (
                    <FormattedText
                        value="easyLoanTypeCRequestStepThree-almostDoneSub"
                        className="easy-loan-request-step-three__message"
                    />
                )}
                {maxSizeTextAllowedText}
                {__CONTACT_CENTER__ && !isPrintOfficeMode() ? null :
                    <div className="easy-loan-request-step-three__upload">
                        <EasyLoanRequestUpload
                            clearErrorsFile={clearErrorsFile}
                            removeUploadedFile={removeUploadedFile}
                            immContractEasyLoan={immContractEasyLoan}
                            loadFileInUpload={loadFileInUpload}
                            recordStatus={recordStatus}
                            handlerEditFileName={handlerEditFileName}
                        />
                    </div>
                }
                {isPrintOfficeMode() && officeText}
            </div>
        );
    }
}

ContractEasyLoanTypeCStep3.propTypes = {
    handlerEditFileName: PropTypes.func.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired,
    isDragoFeature: PropTypes.bool.isRequired,
    clearErrorsFile: PropTypes.func.isRequired,
    removeUploadedFile: PropTypes.func.isRequired,
    loadFileInUpload: PropTypes.func.isRequired,
    showPurposeTitle: PropTypes.bool,
    recordStatus: PropTypes.string.isRequired,
    resetUploadConfig: PropTypes.func.isRequired,
    loadFilesPersonalLoan: PropTypes.func.isRequired,
    loadFilesEasyLoan: PropTypes.func
};

module.exports = ContractEasyLoanTypeCStep3;
